import Swiper from "swiper/bundle";

let swiperInstance;

function initializeSwiper() {
  if (window.innerWidth <= 767) { // mobile view threshold
    if (!swiperInstance) { // Initialize only if not already initialized
      swiperInstance  = new Swiper(".grid-column-swiper", {
        slidesPerView: 2,
        grid: {
          rows: 3,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".pagination-arrow-wrap .swiper-pagination",
          clickable: true,
        },
      });
    }
  } else {
    if (swiperInstance) {
      swiperInstance.destroy(true, true); // Destroy the swiper if it's initialized
      swiperInstance = null;
    }
  }
}

// Initialize on page load
initializeSwiper();

// Reinitialize on window resize
window.addEventListener("resize", initializeSwiper);